export default "__VITE_ASSET__CupRvNbq__"